<template>
    <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        background>
    </el-pagination>
</template>

<script>
export default {
    props: ['currentPage', 'pageSize', 'total'],
    data() {
        return {
            
        }
    },
    methods: {
        handleSizeChange(val) {
            this.$emit('update:pageSize', val);
            this.$parent.search(1)
        },
        handleCurrentChange(val) {
            this.$emit('update:currentPage', val);
            this.$parent.search(val)
        },
    },
}
</script>